import { CountriesEntity } from '../entities';
import { CountriesPayloadForm } from '../ports/payloads';
import { CountriesRepository } from '../ports/repositories';

export class UpdateCountriesUsecase {
  constructor(private readonly repo: CountriesRepository) {}

  async run(payload: CountriesPayloadForm): Promise<CountriesEntity> {
    const data = this.repo.updateCountry(payload);
    return data;
  }
}
